import { render, staticRenderFns } from "./messageTimes.vue?vue&type=template&id=3bb885be&scoped=true"
import script from "./messageTimes.vue?vue&type=script&lang=js"
export * from "./messageTimes.vue?vue&type=script&lang=js"
import style0 from "./messageTimes.vue?vue&type=style&index=0&id=3bb885be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb885be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb885be')) {
      api.createRecord('3bb885be', component.options)
    } else {
      api.reload('3bb885be', component.options)
    }
    module.hot.accept("./messageTimes.vue?vue&type=template&id=3bb885be&scoped=true", function () {
      api.rerender('3bb885be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/news/components/messageTimes.vue"
export default component.exports